import { render, staticRenderFns } from "./bsp-dialog-demo.vue?vue&type=template&id=1360449c&scoped=true&"
import script from "./bsp-dialog-demo.vue?vue&type=script&lang=js&"
export * from "./bsp-dialog-demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1360449c",
  null
  
)

export default component.exports